var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import React from "react";
import { ErrorType } from "../types/ErrorType";
var fieldErrorMapping = (_a = {},
    _a[ErrorType.PUBLISHER_PREFIX_START_NUMBER_LENGTH_INVALID] = "start",
    _a[ErrorType.PUBLISHER_PREFIX_END_NUMBER_LENGTH_INVALID] = "end",
    _a[ErrorType.PUBLISHER_PREFIX_MAGNITUDE_INVALID] = "magnitude",
    _a[ErrorType.PUBLISHER_PREFIX_RANGE_START_IN_ANOTHER_RANGE] = "start",
    _a[ErrorType.PUBLISHER_PREFIX_RANGE_OVERLAPS_ANOTHER_RANGE] = "start",
    _a[ErrorType.PUBLISHER_PREFIX_RANGE_END_IN_ANOTHER_RANGE] = "end",
    _a[ErrorType.PUBLISHER_PREFIX_RANGE_END_BEFORE_START] = "end",
    _a[ErrorType.PUBLISHER_PREFIX_ALREADY_ASSIGNED] = "agencyPrefix",
    _a[ErrorType.NO_ACTIVE_PUBLISHER_PREFIX_RANGES] = "magnitude",
    _a[ErrorType.NO_AVAILABLE_PUBLISHER_PREFIX_VALUES] = "magnitude",
    _a);
var generalErrorTypes = [
    ErrorType.INTERNAL,
    ErrorType.FOLIO_EXTERNAL_OR_UNDEFINED,
    ErrorType.EXTERNAL_OR_UNDEFINED,
    ErrorType.UNKNOWN,
];
var defaultErrorMessages = (_b = {},
    _b[ErrorType.PUBLISHER_PREFIX_MAGNITUDE_INVALID] = "Invalid magnitude value",
    _b[ErrorType.PUBLISHER_PREFIX_END_NUMBER_LENGTH_INVALID] = "End number length is invalid",
    _b[ErrorType.PUBLISHER_PREFIX_RANGE_END_IN_ANOTHER_RANGE] = "End number is within another existing range: {value}",
    _b[ErrorType.PUBLISHER_PREFIX_RANGE_END_BEFORE_START] = "End number must be greater than start number",
    _b[ErrorType.PUBLISHER_PREFIX_RANGE_OVERLAPS_ANOTHER_RANGE] = "Range overlaps with another existing range: {value}",
    _b[ErrorType.PUBLISHER_PREFIX_ALREADY_ASSIGNED] = "Publisher prefix is already assigned",
    _b[ErrorType.PUBLISHER_PREFIX_START_NUMBER_LENGTH_INVALID] = "Start number length is invalid",
    _b[ErrorType.PUBLISHER_PREFIX_RANGE_START_IN_ANOTHER_RANGE] = "Start number is within another existing range: {value}",
    _b[ErrorType.NO_ACTIVE_PUBLISHER_PREFIX_RANGES] = "No active publisher prefix range is available for the selected size and agency prefix. Please create a matching range in the Publisher prefix ranges section.",
    _b[ErrorType.NO_AVAILABLE_PUBLISHER_PREFIX_VALUES] = "All active publisher prefix ranges for the selected magnitude and agency prefix are exhausted",
    _b[ErrorType.PREFIX_DECLARATION_PENDING] = "Publisher prefix awaits last-used-number declaration",
    _b[ErrorType.INTERNAL] = "Internal server error",
    _b[ErrorType.FOLIO_EXTERNAL_OR_UNDEFINED] = "External system error",
    _b[ErrorType.EXTERNAL_OR_UNDEFINED] = "External error occurred",
    _b[ErrorType.UNKNOWN] = "Unknown error occurred",
    _b);
function parseServerErrors(errorsResponse) {
    var errors = [];
    try {
        if ((errorsResponse === null || errorsResponse === void 0 ? void 0 : errorsResponse.errors) && Array.isArray(errorsResponse.errors)) {
            errors.push.apply(errors, errorsResponse.errors.map(function (err) { return ({
                code: err.type || err.code || ErrorType.UNKNOWN,
                message: err.message || "",
                field: err.field,
            }); }));
        }
        if (errors.length === 0) {
            errors.push({
                code: ErrorType.UNKNOWN,
                message: "An unknown error occurred",
            });
        }
    }
    catch (parseError) {
        console.error("Error parsing server errors:", parseError);
        errors.push({
            code: ErrorType.UNKNOWN,
            message: "An unknown error occurred",
        });
    }
    return errors;
}
function extractDynamicValue(message) {
    if (!message)
        return null;
    var colonIndex = message.lastIndexOf(": ");
    if (colonIndex === -1)
        return null;
    var value = message.substring(colonIndex + 2).trim();
    return value || null;
}
export function handlePublisherPrefixRangeError(errorsResponse, formatMessage) {
    var serverErrors = parseServerErrors(errorsResponse);
    var fieldErrors = {};
    var generalErrors = [];
    serverErrors.forEach(function (serverError) {
        var code = serverError.code, message = serverError.message;
        var errorMessage = message || defaultErrorMessages[code] || "An error occurred";
        if (formatMessage && defaultErrorMessages[code]) {
            try {
                var dynamicValue = extractDynamicValue(message);
                var defaultMsg = defaultErrorMessages[code];
                var needsValue = defaultMsg.includes("{value}");
                if (needsValue && !dynamicValue) {
                    errorMessage = message || defaultMsg;
                }
                else {
                    errorMessage = formatMessage({
                        id: "ui-br-agency.publisher-prefix-range.error.".concat(code),
                        defaultMessage: defaultMsg,
                    }, needsValue ? { value: dynamicValue } : undefined);
                }
            }
            catch (_a) {
                errorMessage = defaultErrorMessages[code] || errorMessage;
            }
        }
        if (generalErrorTypes.includes(code)) {
            generalErrors.push(errorMessage);
        }
        else {
            var mappedField = serverError.field || fieldErrorMapping[code] || "generalErrors";
            if (mappedField === "generalErrors") {
                generalErrors.push(errorMessage);
            }
            else {
                if (!fieldErrors[mappedField]) {
                    fieldErrors[mappedField] = [];
                }
                fieldErrors[mappedField].push(errorMessage);
            }
        }
    });
    var modalErrors = __spreadArray(__spreadArray([], Object.values(fieldErrors).flat(), true), generalErrors, true);
    return { fieldErrors: fieldErrors, generalErrors: generalErrors, modalErrors: modalErrors };
}
export function formatModalErrors(errors) {
    if (errors.length === 1)
        return errors[0];
    return (React.createElement("ol", { style: { margin: 0, paddingLeft: "1.5em", textAlign: "left" } }, errors.map(function (error, index) { return (React.createElement("li", { key: index }, error)); })));
}
export function applyFieldErrors(fieldErrors, setError) {
    Object.entries(fieldErrors).forEach(function (_a) {
        var fieldName = _a[0], messages = _a[1];
        if (messages.length > 0) {
            setError(fieldName, {
                type: "server",
                message: messages[0],
            });
        }
    });
}
